import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { createIdMap } from '../../version_mapping/utility'

export const workingTreeAtom = atom<{ tree?: INode; resetTree?: () => void }>(
  {},
)

export const workingTreeIdMap = atom((get) => {
  const { tree } = get(workingTreeAtom)
  if (!tree) return
  return createIdMap(tree)
})

export const copySourceTreeAtom = atom<INode | undefined>(undefined)

export const copySourceNodeAtom = atom<INode | undefined>(undefined)

export const selectedNodeAtom = atom<INode | undefined>(undefined)

export const selectedDestinationSiblingId = atom('')

export const selectedDestinationSiblingNodeAtom = atom((get) => {
  const nodeId = get(selectedDestinationSiblingId)
  const idMap = get(workingTreeIdMap)
  return idMap?.[nodeId]?.node
})
